import React from 'react';

const TextField = props => {
  const { type = 'text', ...rest } = props;
  return (
    <input
      type={type}
      { ...rest }
    />
  );
};

export default TextField;
